/**
 * @desc sendTaskEndEvent
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(data: defs.FlowTaskEndEvent): Promise<any> {
  return defHttp.post({
    url: '/flow/task/end/event',
    data,
  });
}

export function mock(data: defs.FlowTaskEndEvent): Promise<any> {
  return defHttp.post({
    url: '/mock/flow/task/end/event',
    data,
  });
}
